module.exports = __webpack_public_path__ + "static/media/attribute_time.4f19bd5a.png";